import { createAction } from 'typesafe-actions';

export const newVersion = createAction('VERSION/NEW', (resolve) => {
  return () => resolve();
});

export const ignoreVersion = createAction('VERSION/IGNORE', (resolve) => {
  return () => resolve();
});
